import { apiService } from './apiService';
import { API_BASE_URL } from '../config/env';
import type { User } from './authService';

export interface ClinicProfessional {
  id: number;
  name: string;
  email: string;
  role: 'doctor' | 'nutritionist';
}

export interface ClinicSummary {
  id: number;
  name: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  isActive: boolean;
  createdAt: string;
  /** Active patients of the clinic, counted by the endpoint. */
  patientCount: number;
  /** Active doctors and nutritionists of the clinic. */
  professionals: ClinicProfessional[];
}

export interface ClinicInput {
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  isActive?: boolean;
}

const BASE = `${API_BASE_URL}/clinic/clinics/`;

/** Admin-only clinic management. Doctors get a 403 from every call. */
export const clinicsService = {
  list: async (includeInactive = false): Promise<ClinicSummary[]> =>
    apiService.get(includeInactive ? `${BASE}?include_inactive=true` : BASE),

  get: async (id: string | number): Promise<ClinicSummary> => apiService.get(`${BASE}${id}/`),

  create: async (data: ClinicInput): Promise<ClinicSummary> => apiService.post(BASE, data),

  update: async (id: number, data: Partial<ClinicInput>): Promise<ClinicSummary> =>
    apiService.patch(`${BASE}${id}/`, data),

  /** The same `user` block as the login, so the sidebar sees a renamed or reassigned clinic. */
  me: async (): Promise<User> => apiService.get(`${API_BASE_URL}/clinic/me/`),
};

export const PROFESSIONAL_ROLE_LABEL: Record<ClinicProfessional['role'], string> = {
  doctor: 'Médico',
  nutritionist: 'Nutricionista',
};
